export default __webpack_public_path__ + "assets/check.e04c3374d2c43bd03d5c52b37639d90c.svg";